import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionLoadGridDataRequest,
  actionLoadGridDataSuccess,
  actionLoadGridDataFail,
} from 'react-redux-app/lib/modules/grid/actions';

import { getCurrentSiteId } from '../../site/selectors';

import { actionAddCustomTags } from './index';

import { SITE_CUSTOM_TAGS_GRID_NAME } from '../constants';

import { CUSTOM_TAGS_SCHEMA } from '../schemas';


export const actionLoadSiteCustomTagsRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch(actionLoadGridDataRequest(SITE_CUSTOM_TAGS_GRID_NAME));

    return apiClientHelper.get(
      `/rest/webmaster/site_content/${getCurrentSiteId(getState())}/meta_tag`,
      {},
      CUSTOM_TAGS_SCHEMA
    ).then(
      ({ entities, result }) => {
        dispatch(actionAddCustomTags(entities.customTags));
        dispatch(actionLoadGridDataSuccess(
          SITE_CUSTOM_TAGS_GRID_NAME, result, result.length
        ));
      },
      error => {
        dispatch(actionLoadGridDataFail(SITE_CUSTOM_TAGS_GRID_NAME, error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
